import { API_METHODS, BASE_URL, createHeader } from '../endpointBuilder';
import { axiosRequest } from '../request';
import { ContactUsDTO } from '../../lib/interfaces/ContactUs';

const endpoints = {
	contactUs: (data: ContactUsDTO) => ({
		headers: createHeader(null, false),
		url: `${BASE_URL}/contact`,
		method: API_METHODS.POST,
		data,
	}),
};

export const contactUs = async (data: ContactUsDTO) =>
	axiosRequest(endpoints.contactUs(data));
